import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Five years after Covid-19 regulations first put restrictions on public meetings, the sixth of six posters on our Gondwana work was presented at the 2025 Netherlands Geoscience Congress in Noordwijkerhout on March 20.  The title was `}<strong parentName="p">{`The tectonic history of the Bouvet triple junction and the Southwest Indian Ridge.`}</strong>{` `}</p>
    <p>{`The last 24 months have seen continued refinement of our Gondwana dispersal model while its most important features have remained largely unchanged. We are keener than ever to share these insights into the way in which well-defined mature plate boundaries, such as the present-day mid-ocean ridges in the South Atlantic and Indian oceans, evolved from the often more chaotic rifting patterns of early continental disruption and the micro-fragments created in the early rifting process.`}</p>
    <p>{`The six posters may be seen here and, taken together, serve as a quick summary of the work as a whole:`}</p>
    <p><a parentName="p" {...{
        "href": "/reevesdotnl/cb479dcfd32f85e2e08ba767aa78d712/NAC2025-CVR-small.pdf"
      }}>{`March 2025`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/NAC2024-CR-RS-EA-PC.pdf"
      }}>{`March 2024`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/NAC2023-CVR.pdf"
      }}>{`March 2023`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/NAC2022-CVR.pdf"
      }}>{`September 2022`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/NAC2021-CVR-final.pdf"
      }}>{`March 2021`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/Reeves-NACgeo2020-2pages.pdf"
      }}>{`March 2020`}</a></p>
    <p>{`A talk with the title, `}<strong parentName="p">{`The Bouvet triple junction: a model of fragmentation in Jurassic and Early Cretaceous times,`}</strong>{` was given at the European
Geoscience Union General Assembly in Vienna on 2023 April 20 in Session GD5.1, `}<strong parentName="p">{`Towards new understandings of complex continental margins and oceans`}</strong>{`. The abstract of the talk is here `}<a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/abstract-the-bouvet-triple-junction.pdf"
      }}>{`Reeves, 2023b`}</a>{`.`}</p>
    <p>{`An animation showing the proposed early movements of the micro-fragments around southern Africa is to be seen `}<a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/cr23baag-BTJ-2.gif"
      }}>{`here`}</a>{`.  The animated GIF is almost 30 MB so may take a few seconds to load.`}</p>
    <p>{`A longer talk entiled `}<strong parentName="p">{`Gondwana’s demise: Exploration into the third and fourth dimensions`}</strong>{` was given to the Yorkshire Geological Society on 1 November 2023. A recording with Powerpoint is available on request. `}</p>
    <p>{`Any questions?  Please get in touch (`}<a parentName="p" {...{
        "href": "mailto:reeves.earth@planet.nl"
      }}>{`reeves.earth@planet.nl`}</a>{`)`}</p>
    <p><em parentName="p">{`Updated 2025 May 28`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      